/**
 * Component   : Bank Management
 * Description : Adding a new Bank
 */
import { Grid, Paper } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { callAPI, encryptPassword, EPhone, formatPhoneNumber, generateKey, Method } from "../../../commonFunctions/CommonFunctions";
import WSButton from "../../../Components/Button/WSButton";
import WSPhone from "../../../Components/Phone/WSPhone";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import WSTextField from "../../../Components/TextBox/WSTextBox";
import { Header } from "../../Header/Header";
import { IBank } from "../../Interfaces/Interfaces";
export const Bank: React.FC<any> = React.memo((props) => {
    const { showMessage } = useSnackbar();
    const { register, handleSubmit, control, formState: { }, setValue, watch, reset } = useForm();
    const [isloading, setIsLoading] = useState(false)
    const navigate = useNavigate();
    const params = useParams();
    const id = params?.id;
    useEffect(() => () => {
        reset()
    }, [])
    useEffect(() => {
        /**
         * Method to get the bank record by id for edit purpose
         * @param id 
         */
        async function getBankById(id: any): Promise<void> {
            try {
                const response: any = await callAPI('Bank', Method.GET, {}, id);

                if (response && response.data) {

                    for (const field in response.data) {
                        if (field === 'phoneno') {
                            setValue(field, formatPhoneNumber((response?.data as any)[field], EPhone.AddHyphen))
                        }
                        else {
                            setValue(field, (response?.data as any)[field]);
                        }
                    }
                }
            } catch (error) {
                showMessage('Error fetching bank:', 'error');
            }
        }
        getBankById(id);
    }, [id]);

    const handleCancelClick = () => {
        navigate("/bank/list");
    };

    /**
     * Method for Add/Update the data
     * @param data 
     */
    const onSubmit = async (data: any) => {
        try {
            setIsLoading(true)
            const request: any = await setRequest(data);
            if (id) {
                const response: any = await callAPI(`Bank/${id}`, Method.PUT, request);
                if (response) {
                    showMessage(response?.message, response.success === true ? "success" : "error");
                    response.success === true && navigate("/bank/list");
                }
            } else {
                const response: any = await callAPI('Bank', Method.POST, request);
                if (response) {
                    showMessage(response?.message, response.success === true ? "success" : "error");
                    response.success === true && navigate("/bank/list");
                }
            }
        } catch (e: any) {
            showMessage(e.error);
        }
        finally{
            setIsLoading(false)
        }
    };

    /**
     * Method to set the request for the Bank
     * @param data 
     * @returns 
     */
    async function setRequest(data: any) {
      
        let request: IBank = {
            name: data.name,
            location: data?.location || "",
            phoneno: data?.phone ? formatPhoneNumber(data?.phone, EPhone.RemoveHyphen) : "",
        };
        return request;
    }

    return (
        <><Header title={id ? "Edit Bank" : "Add New Bank"} type="simple" url="/bank/list" isBackButton={true} />
            <Paper elevation={3} style={{ paddingLeft: 10, paddingRight: 0, marginTop: 0, paddingBottom: 20, border: '1px solid #ccc', borderRadius: '8px' }}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Grid xs={12} className="modal-input" container spacing={2} style={{ marginTop: 10 }}>
                        <Grid item sm={6} xs={12}>
                            <WSTextField control={control} id="name" {...register('name')} name="name" rules={{ required: true }} label="Bank Name *"></WSTextField>

                        </Grid>
                        <Grid item sm={6} xs={12}>
                            <WSTextField control={control} id="location" {...register('location')} name="location" rules={{ required: false }} label="Location"></WSTextField>
                        </Grid>
                        <Grid item sm={12} xs={12}>
                            <WSPhone control={control} id="phone" {...register('phone')} rules={{ required: false }} name="phone" label="Phone" ></WSPhone>
                        </Grid>
                    </Grid>

                    <Grid item container spacing={2} style={{ paddingTop: '1rem' }} justifyContent={'end'}>
                        <Grid item sx={{ marginRight: 1 }}>
                            <WSButton id='submit' label={"Save"} type="submit" size="medium" loading={isloading} />
                        </Grid>
                        <Grid item sx={{ marginRight: 2 }}>
                            <WSButton id='cancel' label={"Cancel"} type="button" onClick={handleCancelClick} size="medium" className="ws-cancel" />
                        </Grid>
                    </Grid>
                </form>
            </Paper>
        </>
    );
});
